module.exports = __webpack_public_path__ + "fonts/655552e3/proximanova-bold-webfont.woff2";